/******/ (() => { // webpackBootstrap
  var __webpack_exports__ = {};
  Shopify.theme.jsCart = {
    init: function ($section) {

      // Add settings from schema to current object
      //Shopify.theme.jsCart = $.extend(this, Shopify.theme.getSectionData($section));

      this.$section = $section;

      $(document).on('click', '[data-cart-page-delete]', function (e) {
        e.preventDefault();
        const lineID = $(this).data('line-item-key');
        Shopify.theme.jsCart.removeFromCart(lineID);

        return false;
      });

      $(document).on('click', '.linkedDeleteBtn', function (e) {
        e.preventDefault();
        var needToRemoveItems = $(this).attr("data-linkedbutton");
        var boxName = $(this).attr("data-box");
        
        deleteBox(boxName);

        $(needToRemoveItems).addClass("fadeItem");
        var lineItemsToRemove = {};


        $(needToRemoveItems).each(function () {
          var lineItem = parseInt($(this).attr("data-variant-id"));
          lineItemsToRemove[lineItem] = 0; // Set the quantity to 0 to remove the item
        });

        // Construct the object of line item updates
        var updates = { updates: lineItemsToRemove };
        console.log(updates);

        // Make the AJAX request to update the cart
        jQuery.post(window.Shopify.routes.root + 'cart/update.js', updates)
          .then(response => {
            console.log('All items removed from cart:', response);
            setTimeout(function () {
              location.reload();
            }, 2000);

          })
          .fail((xhr, status, error) => {
            console.error('Error removing items from cart:', error);
          });

      });

      // Function to delete a specific box number if it exists
      function deleteBox(boxNumberToDelete) {
        let addedBoxes = localStorage.getItem('added-boxes');

        if (addedBoxes) {
          addedBoxes = JSON.parse(addedBoxes);
          if (addedBoxes[boxNumberToDelete]) {
            delete addedBoxes[boxNumberToDelete];
            localStorage.setItem('added-boxes', JSON.stringify(addedBoxes));

            console.log(`Deleted ${boxNumberToDelete} successfully.`);
          } else {
            console.log(`${boxNumberToDelete} does not exist.`);
          }
        } else {
          console.log('No boxes exist in localStorage.');
        }
      }

      // Prevent the ajax cart form from being submitted when pressing the "Enter" key
      $('#cart_form').keydown(function (e) {
        if (e.keyCode == 13) {
          e.preventDefault();
          return false;
        }
      });

      const cartUpdatedEvent = new CustomEvent('cartUpdated', {
        detail: {
          message: 'Cart was updated',
        }
      });
      document.dispatchEvent(cartUpdatedEvent);

    },
    removeFromCart: function (lineID) {
      const $cartItem = Shopify.theme.jsCart.$section.find(`[data-line-item="${lineID}"]`);

      $cartItem.css('opacity', '0.5');

      $.ajax({
        type: 'POST',
        url: '/cart/change.js',
        data: 'quantity=0&line=' + lineID,
        dataType: 'json',
        success: function (cart) {

          $cartItem.addClass('animated zoomOut')
          $cartItem.remove();

          Shopify.theme.jsCart.updateView(cart, lineID);

          if (typeof Shopify.theme.jsAjaxCart !== 'undefined') {
            Shopify.theme.jsAjaxCart.updateView();
          }
        },
        error: function (XMLHttpRequest, textStatus) {
          var response = eval('(' + XMLHttpRequest.responseText + ')');
          response = response.description;
        }
      });
    },
    updateView: function (cart, lineID) {

      if (cart.item_count > 0) {
        $.ajax({
          dataType: "json",
          async: false,
          cache: false,
          dataType: 'html',
          url: "/cart",
          success: function (html) {

            if (lineID !== null) {

              const updatedItems = $(html).find('.cart__item-list .cart__card');
              const currentItems = $('.cart__item-list .cart__card');

              // Checks if BOGO applied and there is a change in the number of line items
              if (updatedItems.length != currentItems.length) {
                const updatedCartList = $(html).find('.cart__item-list');
                // Re-append cart items
                $('.cart__item-list').replaceWith(updatedCartList);
              }

              $(currentItems).each(function (index, element) {
                $(element).attr('data-line-item', (index + 1));
                $(element).find('[data-line-item-key]').attr('data-line-item-key', (index + 1));
              })

              const itemTotal = $(html).find(`[data-line-item="${lineID}"]`).find('.cart__total');
              const quantityInput = $(html).find(`[data-line-item="${lineID}"]`).find('.quantity-input');
              const itemPrice = $(html).find(`[data-line-item="${lineID}"]`).find('.cart__price');

              $(`[data-line-item="${lineID}"]`).find('.cart__total').replaceWith(itemTotal);
              $(`[data-line-item="${lineID}"]`).find('.quantity-input').replaceWith(quantityInput);
              $(`[data-line-item="${lineID}"]`).find('.cart__price').replaceWith(itemPrice);

            }

            const subtotal = $(html).find('.cart__subtotal-container');
            const discounts = $(html).find('.cart__discounts');
            const savings = $(html).find('.cart__total-savings');

            $('.cart__subtotal-container').replaceWith(subtotal);

            if (discounts.length > 0 && $('.cart__discounts').length < 1) {
              $('.cart__subtotal-container').before(discounts);
            } else {
              $('.cart__discounts').replaceWith(discounts);
            }

            if (savings.length > 0 && $('.cart__total-savings').length < 1) {
              $('.cart__subtotal-container').after(savings);
            } else {
              $('.cart__total-savings').replaceWith(savings);
            }

            $('[data-bind="itemCount"]').text(cart.item_count);

          }
        });

      } else {
        $('.cart__empty-cart-message').removeClass('is-hidden');
        $('.cart__form').addClass('is-hidden');
        $('[data-ajax-cart-trigger]').removeClass('has-cart-count');
        $('[data-bind="itemCount"]').text('0');
      }

    },
    unload: function ($section) {
      // Clear event listeners in theme editor
      $('[data-cart-page-delete]').off();
      $('#cart_form').off();
    }
  }

  /******/
})()
  ;